module.exports = __webpack_public_path__ + "static/korol_video-c3df51a3604c0ffd9e706cf96ae53e7b.mp4";